export const region = process.env.REACT_APP_AWS_REGION;
export const userPoolId = process.env.REACT_APP_USER_POOL_ID;
export const userPoolWebClientId = process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID;
export const endpoint = process.env.REACT_APP_BASE_API_URL;
